class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    this.links = this.querySelectorAll(".js-scroll-link");

    this.jumpNavigation = this.querySelector(".collapsible-content__nav");

    this.links.forEach((link) => {
      link.addEventListener("click", (event) => this.handleClick(event, link));
    });
  }

  handleClick(event, link) {
    event.preventDefault();

    const target = document.querySelector(link.getAttribute("href"));

    if (!target) return;

    this.updateLinks(link);

    if (this.jumpNavigation.classList.contains("collapsible__nav-constrain")) {
      this.querySelector(
        ".collapsible-content__target--active"
      )?.classList.remove("collapsible-content__target--active");
      target.classList.add("collapsible-content__target--active");
    } else {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }

  updateLinks(link) {
    this.links.forEach((link) => {
      link.classList.remove("collapsible-content__link--active");
    });

    link.classList.add("collapsible-content__link--active");
  }
}

customElements.define("collapsible-content", CollapsibleContent);
